import { HttpErrorResponse } from '@angular/common/http';

export const partnerNotFoundByMpnId = (error: HttpErrorResponse): boolean => {
  if (!error || !error.url) {
    return false;
  }
  const regexResult = error.url!.match(/csp\/get-partner-name-by-mpn-id/);
  return !!regexResult;
};
